export default "__VITE_ASSET__CKnlSqEU__"